import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import {
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
} from '@mui/material';

function BookSearch() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem('token'); // Retrieve the token from localStorage

  const searchBooks = async () => {
    if (!query.trim()) {
      alert('Please enter a search term.');
      return;
    }
    try {
      const res = await axios.get(
        `${API_BASE_URL}/books/search?q=${encodeURIComponent(query)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setResults(res.data.items || []);
    } catch (err) {
      console.error('Error fetching books:', err);
      alert('Failed to fetch books. Please try again later.');
    }
  };

  // Navigate to BookDetails page with book data
  const navigateToBookDetails = (book) => {
    const checkAndNavigate = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/books/google/${encodeURIComponent(book.id)}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log('Book exists:', res.data);
        if (res.data) {
          // Book exists in the database
          navigate(`/book/${res.data._id}`);
          
        } else {
          // Book does not exist, navigate to 'new' with book data
          navigate('/book/new', { state: { book } });
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          // Book does not exist, navigate to 'new' with book data
          navigate('/book/new', { state: { book } });
        } else {
          console.error('Error checking if book exists:', err);
          alert('An error occurred while checking the book. Please try again later.');
        }
      }
    };
    checkAndNavigate();
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', fontWeight: 600 }}>
        Search for Books
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        label="Enter book title or author"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        sx={{ mb: 2 }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            searchBooks();
          }
        }}
      />
      <Button
        variant="contained"
        onClick={searchBooks}
        sx={{
          display: 'block',
          mx: 'auto',
          mb: 4,
          backgroundColor: '#8D7B68',
          '&:hover': { backgroundColor: '#7A6859' },
          color: '#fff',
          borderRadius: 2,
        }}
      >
        Search
      </Button>

      <Grid container spacing={3}>
        {results.map((book) => (
          <Grid item xs={12} sm={6} md={4} key={book.id}>
            <Card
              onClick={() => navigateToBookDetails(book)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': { transform: 'scale(1.03)', cursor: 'pointer' },
                borderRadius: '16px',
                backgroundColor: '#FAF3E0',
              }}
            >
              {book.volumeInfo.imageLinks?.thumbnail && (
                <Box
                  sx={{
                    width: '100%',
                    aspectRatio: '2/3',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                  }}
                >
                  <CardMedia
                    component="img"
                    image={book.volumeInfo.imageLinks.thumbnail}
                    alt={book.volumeInfo.title}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </Box>
              )}
              <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#333', fontSize: '1rem' }}>
                  {book.volumeInfo.title}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary" sx={{ color: '#555' }}>
                  {book.volumeInfo.authors?.join(', ')}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  {book.volumeInfo.description
                    ? `${book.volumeInfo.description.substring(0, 60)}...`
                    : 'No description available.'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default BookSearch;
